export default __webpack_public_path__ + "static/media/chat.88695ba5.png";